/** @jsx jsx */
import { useTranslate } from '@chordcommerce/gatsby-theme-autonomy'
import React from 'react'
import { Flex, Label, Radio, Text, jsx } from 'theme-ui'
import { experiments, useExperiment } from '~/hooks/utils/use-experiment'

export const AddToCartProductListFrequency = ({
  subscriptionValue,
  setSubscriptionValue,
  subscriptionData,
  regularPrice,
  variants,
  promoDiscountPrice,
  discountPercentage, // OMS /Contentful discount percentage - NOT Subscription
  discountToSubscription, // OMS /Contentful discount percentage - check if it applies to subs
  collectionName,
}) => {
  const translate = useTranslate()
  const priceAfterDiscount =
    regularPrice * (1 - subscriptionData.discountPercentage / 100)

  const collectionsCardsTest = useExperiment(experiments.newProductCardLayout)

  // check if the CMS discount is higher than sub discount
  const hasHigherDiscountThanSub =
    discountToSubscription &&
    discountPercentage > subscriptionData?.discountPercentage

  return (
    <Flex
      sx={{
        flexDirection: 'column',
        gap: '8px',
        alignItems: 'center',
        width: '100%',
        mb: '16px',
      }}
    >
      <Text
        as="span"
        sx={{
          fontWeight: '900',
          fontSize: ['12px', '18px'],
        }}
      >
        Frequency:
      </Text>

      <Flex
        sx={{
          flexDirection: 'column',
          gap: ['8px', '10px'],
        }}
      >
        <Label
          sx={{
            textTransform: 'capitalize',
            cursor: 'pointer',
          }}
        >
          <Flex
            sx={{
              alignItems: 'center',
              fontFamily:
                subscriptionValue === 'subscribe-and-save' ? 'heading' : 'body',
            }}
          >
            <Radio
              checked={subscriptionValue === 'subscribe-and-save'}
              onChange={({ target }) => setSubscriptionValue(target.value)}
              name={`subscription-type-${variants[0].globalTradeItemNumber}-${collectionName}-${variants[0].sku}`}
              value="subscribe-and-save"
              sx={{
                borderColor: 'var(--theme-ui-colors-primary) !important',
                color: 'var(--theme-ui-colors-secondary) !important',
                backgroundColor: 'var(--theme-ui-colors-secondary) !important',
                width: '18px',
                height: '18px',
              }}
            />

            <Text
              as="span"
              sx={{
                fontSize: ['12px', '16px'],
              }}
            >
              <Text
                as="span"
                sx={{
                  display: ['none', 'inline-block'],
                }}
              >
                $
                {hasHigherDiscountThanSub
                  ? promoDiscountPrice?.toFixed(2)
                  : priceAfterDiscount.toFixed(2)}{' '}
                -
              </Text>{' '}
              Subscribe and Save (
              {hasHigherDiscountThanSub
                ? discountPercentage
                : subscriptionData?.discountPercentage}
              % Off)
            </Text>
          </Flex>
        </Label>

        <Label
          sx={{
            textTransform: 'capitalize',
            cursor: 'pointer',
          }}
        >
          <Flex
            sx={{
              alignItems: 'center',
              fontFamily:
                subscriptionValue === 'one-time-purchase' ? 'heading' : 'body',
            }}
          >
            <Radio
              checked={subscriptionValue === 'one-time-purchase'}
              onChange={({ target }) => setSubscriptionValue(target.value)}
              name={`subscription-type-${variants[0].globalTradeItemNumber}-${collectionName}-${variants[0].sku}`}
              value="one-time-purchase"
              sx={{
                borderColor: 'var(--theme-ui-colors-primary) !important',
                color: 'var(--theme-ui-colors-secondary) !important',
                backgroundColor: 'var(--theme-ui-colors-secondary) !important',
                width: '18px',
                height: '18px',
              }}
            />

            <Text
              as="span"
              sx={{
                fontSize: ['12px', '16px'],
              }}
            >
              <Text
                as="span"
                sx={{
                  display: ['none', 'inline-block'],
                }}
              >
                ${promoDiscountPrice?.toFixed(2) || regularPrice} -
              </Text>{' '}
              {translate('subscriptions.one_time_purchase')}
              {promoDiscountPrice ? ` (${discountPercentage}% Off)` : ''}
            </Text>
          </Flex>
        </Label>
      </Flex>
    </Flex>
  )
}
